import TextareaQuestionSurface from "./TextareaQuestionSurface";

export const SURFACE_10_LABEL = "What do they enjoy outside of work?";
export const SURFACE_10_PLACEHOLDER = "Hobbies, interests, things they actually choose to do...";
export const SURFACE_10_ERROR = "Even a couple of things helps.";

export default function Surface10(props) {
  return (
    <TextareaQuestionSurface
      current={6}
      label={SURFACE_10_LABEL}
      placeholder={SURFACE_10_PLACEHOLDER}
      errorCopy={SURFACE_10_ERROR}
      name="recipient_enjoys"
      {...props}
    />
  );
}
